module.exports = __webpack_public_path__ + "img/Group 7686.98c3e0a6.svg";